export const TRANSLATION_SCOPE = 'questionnaireSelectModule';
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
